"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { analytics } from "@/lib/analytics";
import { isMeritLensAnalyticsExcludedPath } from "@/lib/analytics/excludedPaths";
import { ANALYTICS_ENABLED } from "@/lib/config";

/**
 * Browser-only MeritLens analytics identity + automatic events.
 * Independent of GA4 / GTM (`app/analytics-provider.tsx`).
 */
export default function MeritLensAnalyticsProvider() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!ANALYTICS_ENABLED) return;
    if (isMeritLensAnalyticsExcludedPath(pathname)) return;
    analytics.init();
  }, [pathname]);

  useEffect(() => {
    if (!ANALYTICS_ENABLED) return;
    if (isMeritLensAnalyticsExcludedPath(pathname)) return;
    analytics.track("page_view", {
      pageType: pathname === "/dussehra-offer" ? "dussehra_offer" : undefined,
      path: pathname,
      query: searchParams?.toString() || undefined,
    });
  }, [pathname, searchParams]);

  return null;
}
